// extracted by mini-css-extract-plugin
module.exports = {"reset-form__send":"_1x66a","reset-form":"_1fJln","title__primary":"bh7Ic","title__secondary":"_3ENKN","reset-form__title":"BCnff","title":"_3NiqR"};